import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { encodedStudentInfo } from "../../App";
import { encodedpayment } from "../../App";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import Footer from "../shared/Footer";
import config from "../../config";
import ScrutinyPDF from "../ScrutinyPDF";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { motion, AnimatePresence } from "framer-motion";

function Dashboard() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);
  const [scrutinyData, setScrutinyData] = useState(null);
  const [scrutinyLoading, setScrutinyLoading] = useState(false);

  const [infomodal, setInfomodal] = useState(false);
  const [studentData, setStudentData] = useState(null);
  const movetostudentinfo = () => {
    navigate("/student-info");
  };
  const movetopayment = () => {
    navigate("/student-payment");
  };
  useEffect(() => {
    const fetchData = async () => {
      const token = sessionStorage.getItem("tokenclassxii");

      if (!token) {
        navigate("/");
        return;
      }
      try {
        const token = sessionStorage.getItem("tokenclassxii");
        const rollno = sessionStorage.getItem("rollnumberxii");
        const rollcode = sessionStorage.getItem("rollcodexii");
        const phoneNumber = sessionStorage.getItem("phoneNumber");

        const response = await fetch(
          `${config.API_BASE_URL}/FetchDashBoardClass12`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              rollno: rollno,
              rollcode: rollcode,
              CONTACT_NO: phoneNumber
            }),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log(data.data);
        sessionStorage.setItem(
          "ApplicationStatus",
          data.data.ApplicationStatus
        );
        sessionStorage.setItem("PaymentStatus", data.data.PaymentStatus);
        
        sessionStorage.setItem("CLASS_12_PAYMENT_ON_OFF", data.data.CLASS_12_PAYMENT_ON_OFF);
        // debugger;
        setDashboardData(data.data || {});
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleDownloadApplication = async (e) => {
    e.preventDefault();
    setScrutinyLoading(true);
    try {
      const token = sessionStorage.getItem("tokenclassxii");
      const rollno = sessionStorage.getItem("rollnumberxii");
      const rollcode = sessionStorage.getItem("rollcodexii");

      const response = await fetch(
        `${config.API_BASE_URL}/ScrutinyReceiptReportClass12`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ROLLCODE: rollcode, ROLLNO: rollno }),
        }
      );

      if (!response.ok) throw new Error("Failed to fetch scrutiny data");
      const data = await response.json();

      const blob = await pdf(<ScrutinyPDF data={data.data} />).toBlob();
      saveAs(blob, "scrutiny-application.pdf");
    } catch (err) {
      console.error("PDF download error:", err);
    } finally {
      setScrutinyLoading(false);
    }
  };
   const openmodal = async () => {
    setInfomodal(true);
    setLoading(true);
    setStudentData(null);
 const token = sessionStorage.getItem("tokenclassxii");
        const rollno = sessionStorage.getItem("rollnumberxii");
        const rollcode = sessionStorage.getItem("rollcodexii");
    try {
      const response = await fetch(`${config.API_BASE_URL}/GetClass12ScrutinyStatus`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          rollno: rollno,
          rollcode: rollcode
        }),
      });

      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.json();
      setStudentData(data.data); // bind response to modal
    } catch (error) {
      console.error("Error fetching student details:", error);
      setStudentData({ error: "No data available." });
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div class="container-scroller">
        <Navbar />
        <div class="container-fluid page-body-wrapper">
          <Sidebar />
          <div class="main-panel">
            <div class="content-wrapper">
              <section class="content-header mb-5">
                <h3 class="content-header-text">
                  WELCOME, {sessionStorage.getItem("candidatenamexii")}
                </h3>

                <h3></h3>
              </section>
              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="text-center position-relative">
                        <a
                          {...(dashboardData?.ApplicationStatus === "NO"
                            ? {
                              href: "#",
                              onClick: movetostudentinfo,
                              style: {
                                width: "120px",
                                height: "120px",
                                cursor: "pointer",
                              },
                            }
                            : {
                              style: {
                                width: "120px",
                                height: "120px",
                                cursor: "not-allowed",
                                pointerEvents: "none",
                              },
                            })}
                          class="step-icon mx-auto bg-brown border rounded-circle d-flex align-items-center justify-content-center"
                        >
                          <i
                            class="fa fa-file-text text-white fs-1"
                            aria-hidden="true"
                          ></i>
                        </a>

                        <h4 class="mt-3 fs-5">My Application Form</h4>
                        {dashboardData?.ApplicationStatus === "NO" ? (
                          <p
                            class="lead text-danger mt-2 fs-5 px-lg-3 mb-5 mb-lg-0"
                            style={{ fontWeight: "600" }}
                          >
                            Not Submitted
                          </p>
                        ) : (
                          <p
                            class="lead text-success mt-2 fs-5 px-lg-3 mb-5 mb-lg-0"
                            style={{ fontWeight: "600" }}
                          >
                            Submitted
                          </p>
                        )}

                        <p style={{ marginTop: "5px" }}>
                          {dashboardData?.ApplicationStatus === "NO" ? (
                            <a
                              href="#"
                              className="blink"
                              onClick={movetostudentinfo}
                            >
                              <strong
                                className="text-success"
                                style={{ textDecoration: "underline" }}
                              >
                                Click Here to Apply
                              </strong>
                            </a>
                          ) : scrutinyLoading ? (
                            <span className="text-muted">Preparing PDF...</span>
                          ) : (
                            <a
                              href=""
                              onClick={handleDownloadApplication}
                              style={{
                                marginTop: "10px",
                                textDecoration: "underline",
                                color: "green",
                                fontWeight: "bold",
                                cursor: "pointer",
                              }}
                            >
                              {scrutinyLoading
                                ? "Preparing PDF..."
                                : "Download Application"}
                            </a>
                          )}
                        </p>
                        <div
                          class="arrow-icon"
                          style={{
                            top: "50px",
                            right: "-25px",
                            position: "absolute",
                            display: "block",
                          }}
                        >
                          <svg
                            class="bi bi-arrow-right"
                            fill="currentColor"
                            height="30"
                            viewBox="0 0 16 16"
                            width="30"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                              fill-rule="evenodd"
                            ></path>
                          </svg>
                        </div>
                      </div>
                    </div>
                     {sessionStorage.getItem("CLASS_12_PAYMENT_ON_OFF") === "ON" && (
                    <div className="col-md-4">
                      <div className="text-center position-relative">
                        <a
                          {...(sessionStorage.getItem("CLASS_12_PAYMENT_ON_OFF") === "ON" && dashboardData?.ApplicationStatus === "YES" &&
                            ["F", "NO"].includes(dashboardData?.PaymentStatus)
                            ? {
                              href: "#",
                              onClick: movetopayment,
                            }
                            : {})}
                          className="step-icon mx-auto bg-brown border rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: "120px", height: "120px" }}
                        >
                          <i
                            className="fa fa-credit-card text-white fs-1"
                            aria-hidden="true"
                          ></i>
                        </a>

                        <h4 className="mt-3 fs-5">My Fees Payment</h4>

                        {dashboardData?.PaymentStatus === "S" && (
                          <p
                            className="lead text-success mt-2 fs-5 px-lg-3 mb-5 mb-lg-0"
                            style={{ fontWeight: "600" }}
                          >
                            Paid
                          </p>
                        )}
                        {dashboardData?.PaymentStatus === "NO" && (
                          <p
                            className="lead text-danger mt-2 fs-5 px-lg-3 mb-5 mb-lg-0"
                            style={{ fontWeight: "600" }}
                          >
                            Not Paid
                          </p>
                        )}

                        {dashboardData?.PaymentStatus === "P" && (
                          <p
                            className="lead text-warning mt-2 fs-5 px-lg-3 mb-5 mb-lg-0"
                            style={{ fontWeight: "600" }}
                          >
                            Payment Pending
                          </p>
                        )}

                        {dashboardData?.PaymentStatus === "F" && (
                          <p
                            className="lead text-danger mt-2 fs-5 px-lg-3 mb-5 mb-lg-0"
                            style={{ fontWeight: "600" }}
                          >
                            Payment Failed
                          </p>
                        )}

                        <p style={{ marginTop: "5px" }}>
                          {sessionStorage.getItem("CLASS_12_PAYMENT_ON_OFF") === "ON" && dashboardData?.ApplicationStatus === "YES" &&
                            ["F", "NO"].includes(dashboardData?.PaymentStatus) && (
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  movetopayment();
                                }}
                                href="#"
                                className="blink"
                              >
                                <strong
                                  className="text-success"
                                  style={{ textDecoration: "underline" }}
                                >
                                  Click Here for Payment
                                </strong>
                              </a>
                            )}

                          {dashboardData?.PaymentStatus === "P" && (
                            <strong className="text-warning">
                              Waiting for confirmation
                            </strong>
                          )}
                        </p>

                        <div
                          className="arrow-icon"
                          style={{
                            top: "50px",
                            right: "-25px",
                            position: "absolute",
                            display: "block",
                          }}
                        >
                          <svg
                            className="bi bi-arrow-right"
                            fill="currentColor"
                            height="30"
                            viewBox="0 0 16 16"
                            width="30"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                              fillRule="evenodd"
                            ></path>
                          </svg>
                        </div>
                      </div>
                    </div>
                     )}
                    <div class="col-md-4">
                      <div class="text-center position-relative">
                        {dashboardData?.ApplicationStatus === "YES" ? (
                          <button onClick={handleDownloadApplication}
                            class="step-icon mx-auto bg-brown border rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: "120px", height: "120px" }}
                          >
                            <i
                              class="fa fa-print text-white fs-1"
                              aria-hidden="true"
                            ></i>
                          </button>
                        ) : (
                          <div
                            class="step-icon mx-auto bg-brown border rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: "120px", height: "120px" }}
                          >
                            <i
                              class="fa fa-print text-white fs-1"
                              aria-hidden="true"
                            ></i>
                          </div>
                        )}
                        <h4 class="mt-3 fs-5">Application Printed</h4>
                        {dashboardData?.ApplicationStatus !== "YES" ? (
                          <p
                            class="lead text-danger mt-2 fs-5 px-lg-3 mb-5 mb-lg-0"
                            style={{ fontWeight: "600" }}
                          >
                            Not Print
                          </p>
                        ) : (
                          <p
                            class="lead text-success mt-2 fs-5 px-lg-3 mb-5 mb-lg-0"
                            style={{ fontWeight: "600" }}
                          >
                            Printed
                          </p>
                        )}
                        
                     {sessionStorage.getItem("CLASS_12_PAYMENT_ON_OFF") === "OFF" && (
                         <div
                          className="arrow-icon"
                          style={{
                            top: "50px",
                            right: "-25px",
                            position: "absolute",
                            display: "block",
                          }}
                        >
                          <svg
                            className="bi bi-arrow-right"
                            fill="currentColor"
                            height="30"
                            viewBox="0 0 16 16"
                            width="30"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                              fillRule="evenodd"
                            ></path>
                          </svg>
                        </div>
                     )}
                      </div>
                    </div>
                      {sessionStorage.getItem("CLASS_12_PAYMENT_ON_OFF") === "OFF" && (
                        <div className="col-md-4">
                      <div className="text-center position-relative">
                        <div
                          className="step-icon mx-auto bg-brown border rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: "120px", height: "120px" }}
                        >
                          <i className="fa fa-info text-white fs-1" aria-hidden="true"></i>
                        </div>
                        <h4 className="mt-3 fs-5">Status</h4>
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            openmodal();
                          }}
                          href="#"
                          className="blink"
                        >
                          <strong
                            className="text-success"
                            style={{ textDecoration: "underline" }}
                          >
                            Click Here for More Info
                          </strong>
                        </a>
                        {/* {(() => {
                          const status = dashboardData?.STATUS;

                          let colorClass = "text-danger"; // Default red
                          let statusText = "In Progress";

                          if (status === "Working Progress") {
                            colorClass = "text-warning"; // Yellow
                            statusText = "Working Progress";
                          } else if (status === "Completed") {
                            colorClass = "text-success"; // Green
                            statusText = "Completed";
                          }

                          return (
                            <p
                              className={`lead mt-2 fs-5 px-lg-3 mb-5 mb-lg-0 ${colorClass}`}
                              style={{ fontWeight: "600" }}
                            >
                              {statusText}
                            </p>
                          );
                        })()} */}
                      </div>
                    </div>
                      )}
                  </div>
                </div>
                <div class="col-md-1"></div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
      <AnimatePresence>
        {infomodal && (
          <motion.div
            className="modal-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(8px)",
              WebkitBackdropFilter: "blur(8px)",
              zIndex: 1100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                background: "#fff",
                borderRadius: "12px",
                width: "95%",
                maxWidth: "600px",
                position: "relative",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Header */}
              <div
                style={{
                  color: "black",
                  padding: "15px 30px",
                  borderBottom: "1px solid #ddd",
                  fontWeight: "bold",
                  fontSize: "18px",
                  position: "relative",
                }}
              >
                <h5 className="modal-title">Student Details</h5>
                <button
                  type="button"
                  onClick={() => setInfomodal(false)}
                  style={{
                    color: "black",
                    position: "absolute",
                    top: "10px",
                    right: "15px",
                    background: "transparent",
                    border: "none",
                    fontSize: "24px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                  aria-label="Close"
                >
                  &times;
                </button>
              </div>

              {/* Body */}
              <div style={{ padding: "20px 30px", flexGrow: 1 }}>
                {loading ? (
                  <p className="text-center text-muted">Loading student details...</p>
                ) : studentData?.error ? (
                  <p className="text-danger text-center">{studentData.error}</p>
                ) : studentData ? (
                  <>
                    <div className="row mb-1">
                      <div className="col-md-6">
                        <b>Roll Code :</b> {studentData.RollCode}
                      </div>
                      <div className="col-md-6">
                        <b>Roll Number :</b> {studentData.RollNo}
                      </div>
                    </div>
                    <div className="row mb-2">
                      {/* <div className="col-md-6">
                        <b>Stream :</b> {studentData.Stream}
                      </div> */}
                      <div className="col-md-12">
                        <b>Registration No :</b> {studentData.RegistrationNo}
                      </div>
                    </div>

                    <div className="row">
                      <div className="table-responsive">
                        <table className="table table-bordered table-striped table-condensed">
                          <thead>
                            <tr>
                              <th>Subject Code</th>
                              <th>Scrutiny Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {studentData.Subjects?.map((subj, index) => (
                              <tr key={index}>
                                <td>{subj.SubjectName}</td>
                                <td>{subj.Status}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </>
                ) : (
                  <p className="text-center text-muted">No data available</p>
                )}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

export default Dashboard;
